import { ICommonAppConfig } from '../../../Common/app/app.config.token';

import { AuthenticationComponent } from './authentication.component';

export const authenticationAppConfig: ICommonAppConfig = {
	name: 'authentication',
	shouldAuthorize: false,
	mainComponent: AuthenticationComponent,
};
